import type { ReactNode } from 'react';

export const symbol_power_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M412-120q-12.75 0-21.37-8.63Q382-137.25 382-150v-88L256-377q-7.65-7.86-11.83-18.21Q240-405.57 240-417v-192.32q0-24.68 17-42.18t41-17.5l60 60h-58v191l142 155.7v82.3h76v-82l49-54L88-795q-9-9-9-21t9-21q9-9 21-9t21 9l708 708q9 9 9 21t-9 21q-9 9-21 9t-21-9L610-273l-32 35v88q0 12.75-8.62 21.37Q560.75-120 548-120H412Zm280-240-32-32v-217H443L342-710v-100q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v141h156v-141q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v171l-30-30h72q24.75 0 42.38 17.62Q720-633.75 720-609v194q0 11.38-3.5 21.69T705-375l-13 15ZM553-499Zm-114 55Z"
		/>
	</svg>
);
